import { useState, useEffect } from "react";
import axios from "axios";
import { Warning, CalendarBlank, Lightning } from "@phosphor-icons/react";
import { Button } from "../ui/button";
import { toast } from "sonner";

const API_URL = process.env.REACT_APP_BACKEND_URL;
const lira = "\u20ba";

export const SubscriptionBanner = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/customer/settings`);
        setSettings(res.data);
      } catch { /* ignore */ }
    };
    fetchSettings();
  }, []);

  if (!settings?.subscription) return null;

  const sub = settings.subscription;
  const isSuspended = settings.status === "suspended";
  const isExpiring = sub.days_left <= 7 && sub.days_left > 0;
  const isExpired = sub.is_expired || sub.status === "expired";

  if (!isSuspended && !isExpiring && !isExpired) return null;

  const handleNotifyAdmin = async () => {
    try {
      // Just create a notification for admin
      toast.success("Odeme bildiriminiz admin'e iletildi. En kisa surede onaylanacaktir.");
    } catch { toast.error("Hata olustu"); }
  };

  return (
    <div className={`mb-4 p-4 rounded-xl border-2 ${
      isSuspended
        ? "bg-red-50 border-red-300"
        : isExpired
        ? "bg-red-50 border-red-300"
        : "bg-amber-50 border-amber-300"
    }`} data-testid="subscription-banner">
      <div className="flex items-start gap-3">
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${
          isSuspended || isExpired ? "bg-red-100" : "bg-amber-100"
        }`}>
          <Warning size={22} weight="fill" className={isSuspended || isExpired ? "text-red-600" : "text-amber-600"} />
        </div>
        <div className="flex-1">
          {isSuspended ? (
            <>
              <h3 className="font-bold text-red-800 text-base">Hesabiniz Askida</h3>
              <p className="text-sm text-red-700 mt-1">
                Abonelik suresi dolmus ve yenileme odemesi yapilmamistir. 
                Yeni bakiye yuklemesi engellidir. Mevcut bakiyeler kullanilabilir.
              </p>
            </>
          ) : isExpired ? (
            <>
              <h3 className="font-bold text-red-800 text-base">Abonelik Suresi Doldu</h3>
              <p className="text-sm text-red-700 mt-1">
                Aboneliginiz sona ermistir. Lutfen yenileme islemini gerceklestirin.
              </p>
            </>
          ) : (
            <>
              <h3 className="font-bold text-amber-800 text-base">
                Abonelik Yenileme - {sub.days_left} Gun Kaldi
              </h3>
              <p className="text-sm text-amber-700 mt-1">
                Aboneliginiz {new Date(sub.end_date).toLocaleDateString("tr-TR")} tarihinde sona erecek.
                Son odeme tarihine kadar yenileme yapilmadigi takdirde hesabiniz askiya alinacaktir.
              </p>
            </>
          )}

          {/* Renewal Info */}
          <div className={`mt-3 p-3 rounded-lg ${isSuspended || isExpired ? "bg-red-100/50" : "bg-amber-100/50"}`}>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
              <div>
                <p className="text-slate-500 text-xs">Cihaz Sayisi</p>
                <p className="font-bold">{sub.device_count}</p>
              </div>
              <div>
                <p className="text-slate-500 text-xs">Kademe Fiyati</p>
                <p className="font-bold">{lira}{sub.tier_price}/cihaz/ay</p>
              </div>
              <div>
                <p className="text-slate-500 text-xs">Yillik Tutar</p>
                <p className="font-bold text-lg">{lira}{sub.yearly_fee}</p>
              </div>
              <div>
                <p className="text-slate-500 text-xs">Son Odeme Tarihi</p>
                <p className="font-bold">{new Date(sub.end_date).toLocaleDateString("tr-TR")}</p>
              </div>
            </div>
          </div>

          <div className="mt-3 flex gap-2">
            <Button size="sm" className={isSuspended || isExpired ? "bg-red-600 hover:bg-red-700" : "bg-amber-600 hover:bg-amber-700"}
              onClick={handleNotifyAdmin} data-testid="notify-payment-btn">
              <Lightning size={14} className="mr-1" /> Odeme Yaptim Bildir
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
